// extracted by mini-css-extract-plugin
module.exports = {"root":"header_root__lIjZU","right":"header_right__I6lzb"};